import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { getUrlWithVersion } from '../../../api/api'

export const fetchProductSchemaAndConfig = createAsyncThunk<
    { data: any; guid: string; forceUpdate: boolean },
    { guid: string; forceUpdate?: boolean },
    ThunkConfig<string>
>('configsSlice/fetchProductSchemaAndConfig', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { guid, forceUpdate } = args
    try {
        const { data } = await api.get(
            getUrlWithVersion(`/schema_and_configuration/${guid}`)
        )
        return { data, guid, forceUpdate: !!forceUpdate }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch schema and configuration')
    }
})
